import { Star } from "lucide-react";
import { useI18n } from "@/i18n/I18nProvider";

const REVIEWS = [
  {
    name: "Mia",
    country: "🇺🇸 USA",
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&h=200&fit=crop&crop=face",
    text: "Insane quality. Used the anime style for my Twitch profile and got 3x more followers in a week.",
  },
  {
    name: "Lukas",
    country: "🇩🇪 Germany",
    avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop&crop=face",
    text: "The Pixar style is unreal. Made one for my daughter's birthday — she screamed.",
  },
  {
    name: "Sofía",
    country: "🇪🇸 Spain",
    avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&h=200&fit=crop&crop=face",
    text: "Bought the gift pack for my friend group. Best $18 I ever spent. Watercolor style is gorgeous.",
  },
  {
    name: "Tiago",
    country: "🇵🇹 Portugal",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop&crop=face",
    text: "Comic book style turned my LinkedIn photo into something memorable. Pure cyberpunk vibes.",
  },
  {
    name: "Yuki",
    country: "🇯🇵 Japan",
    avatar: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=200&h=200&fit=crop&crop=face",
    text: "アニメスタイルが完璧。30秒で完成して驚きました。また使います。",
  },
  {
    name: "Omar",
    country: "🇦🇪 UAE",
    avatar: "https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?w=200&h=200&fit=crop&crop=face",
    text: "جودة مذهلة وتسليم فوري. النمط الكرتوني الكلاسيكي رائع للهدايا.",
  },
];

export const Testimonials = () => {
  const { t } = useI18n();
  return (
    <section id="reviews" className="py-20 relative">
      <div className="container">
        <div className="text-center mb-12 space-y-3">
          <h2 className="font-display text-4xl md:text-5xl font-black">
            <span className="text-gradient">{t("reviews.title")}</span>
          </h2>
          <p className="text-muted-foreground text-lg">{t("reviews.subtitle")}</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {REVIEWS.map((r, i) => (
            <div
              key={i}
              className="rounded-2xl border border-border bg-card/60 backdrop-blur p-6 hover:border-neon-green/40 hover:-translate-y-1 transition-all"
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, j) => (
                  <Star key={j} className="w-4 h-4 fill-gold text-gold" />
                ))}
              </div>
              <p className="text-sm leading-relaxed mb-5 text-foreground/90">"{r.text}"</p>
              <div className="flex items-center gap-3">
                <img
                  src={r.avatar}
                  alt={`${r.name} testimonial portrait`}
                  loading="lazy"
                  className="w-11 h-11 rounded-full object-cover ring-2 ring-neon-purple/40"
                />
                <div>
                  <div className="font-semibold text-sm">{r.name}</div>
                  <div className="text-xs text-muted-foreground">{r.country}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
